document.querySelectorAll('[data-drawer]').forEach(function(elem) {
  elem.addEventListener('click', function(e) {
    e.preventDefault();
    const nav = document.querySelector('#shopify-section-navigation');
  
    if (nav.classList.contains('active')) {
      nav.classList.remove('active');
    } else {
      nav.classList.add('active');
    };
  });
});

document.querySelectorAll('.navigation .top-item.has-menu').forEach(function(elem) {
  const href = elem.getAttribute('href');
  const linkText = elem.querySelector('span > span').textContent;
  const shopAllItem = document.createElement('div');
  shopAllItem.classList.add('menu-column');
  shopAllItem.classList.add('shop-all');

  const shopAllTitle = document.createElement('h4');
  shopAllTitle.classList.add('link-block-title');

  const shopAllLink = document.createElement('a');
  shopAllLink.setAttribute('href', href);

  const shopAllSpan = document.createElement('span');
  shopAllSpan.textContent = `Shop All ${linkText}`;

  shopAllLink.appendChild(shopAllSpan);
  shopAllTitle.appendChild(shopAllLink);
  shopAllItem.appendChild(shopAllTitle);

  const menu = elem.closest('.item-main').querySelector('.menu .menu-column-wrapper');

  if (menu) {
    menu.prepend(shopAllItem);
  }

  elem.addEventListener('click', function(e) {
    if (window.innerWidth < 990) {
      e.preventDefault();
  
      const item = this.closest('.item-main');
  
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      };
    };
  });
});


document.querySelectorAll('.link-block-title.has-children a').forEach(function(elem) {
  const childHref = elem.getAttribute('href');
  const childText = elem.querySelector('span').textContent;
  const shopAllChildItem = document.createElement('li');

  const shopAllChildLink = document.createElement('a');
  shopAllChildLink.setAttribute('href', childHref);
  shopAllChildLink.textContent = `Shop All ${childText}`;

  shopAllChildItem.appendChild(shopAllChildLink);
  shopAllChildItem.classList.add('shop-all');

  const childMenu = elem.closest('.menu-column').querySelector('ul');

  if (childMenu) {
    childMenu.prepend(shopAllChildItem);
  }

  elem.addEventListener('click', function(e) {
    if (window.innerWidth < 990) {
      e.preventDefault();
  
      const item = this.closest('.menu-column');
  
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      };
    };
  });
});

document.querySelectorAll('.link-block-title.empty-space').forEach(function(elem) {
  const thisMenuCol = elem.closest('.menu-column');
  let prevList = thisMenuCol.previousElementSibling;

  if (prevList.classList.contains('extended-column')) {
    prevList = thisMenuCol.previousElementSibling.previousElementSibling;
  }

  const clone = elem.nextElementSibling.cloneNode(true);

  clone.classList.add('clone');
  prevList.appendChild(clone);
});

document.querySelectorAll('.button-cart-loader').forEach(function(elem) {
  elem.addEventListener('click', function(e) {
    this.classList.add('button-loading');
  });
});
